import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { FrontOffService,MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-menleave',
  templateUrl: './menleave.component.html',
  styleUrls: ['./menleave.component.scss'],
    providers:[FrontOffService,AppGlobals,MasterService]
})
export class MenleaveComponent implements OnInit {

   tab1=1;
       
    
     
     closeResult: string;
      modalOptions:NgbModalOptions;
      private modalRef: NgbModalRef;
       private modalRef1: NgbModalRef;
      arrrmcat: any=[];
      arrbilding: any=[];
      arrhosstu: any=[];
      buid:any;
      selstudent:any={};
      arflstudent: any=[];
     
     dropdownSettings:IDropdownSettings = {singleSelection: false,
           idField: 'stuid',
           textField: 'stunm',
           selectAllText: 'Select All',
           unSelectAllText: 'UnSelect All',
           itemsShowLimit: 0,
           allowSearchFilter: true};
      selected: any;
      rmctid: any;
      arrbeds: any;
      objbed: any={};
      fserdt: any;
      fserdt4: any;
      admdash: any;
       constructor(private http: HttpClient, private mservice:MasterService,private fservice: FrontOffService,private modalService: NgbModal,private apglobal:AppGlobals) {
     
       
        }
     
      
     
      
     
         
     
       ngOnInit(): void {
        
     this.getstudents();
        
        
       
     
       }
      
     
    
     
        getdatetoday() {
        this.fservice.getsysdatetoday()
            .subscribe(
            resultArray => {
                console.log('getlibsource', resultArray);
                this.objbed.stdt = resultArray;
                this.objbed.endt = resultArray;
                this.objbed.rarmk = '';
                // this.recdt = resultArray;
                
            },
            error => console.log("Error :: " + error)
            )
      }
      
    
    
    
      getstudents() {
      this.fservice.getmenleaves()
          .subscribe(
          resultArray => {
              console.log('getlibdepartment', resultArray);
              this.arrhosstu = resultArray.stulst;
              // this.admdash=resultArray.studash;
            
              
          },
          error => console.log("Error :: " + error)
          )
    }
    
  
     openmemdialog(content,formdata) {
       console.log("formdata",formdata);
    //  this.getdatetoday();
    
      this.objbed=formdata;
      this.objbed.bdid='0';
       this.modalOptions = {
         backdrop:'static',
         backdropClass:'customBackdrop',
         size:'md'
        }
       this.modalRef=this.modalService.open(content,this.modalOptions);
      
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
             
          });
         
       
     }
     
     
      openotpdlg(content) {
      //  console.log("formdata",formdata);
    //  this.getdatetoday();
    
      // this.objbed=formdata;
      // this.objbed.bdid='0';
       this.modalOptions = {
         backdrop:'static',
         backdropClass:'customBackdrop',
         size:'sm'
        }
       this.modalRef1=this.modalService.open(content,this.modalOptions);
      
        this.modalRef1.result.then((result) => {
       
             
          }, (reason) => {
             
          });
         
       
     }
     
     
   
     
    
  
      onbedselect(id: any) {
      this.objbed.bdid=id;
     }
    
    
      onmemberselectEvent(item) {
    //alert('hi');
        console.log('item',item);
       }
    
       
      onmemberChangeSearch(sertxt) {
        debugger
      
    
      // this.arflstudent=  this.arrhosstu.filter(user => user.stunm === sertxt.query);
    
      this.arflstudent= this.arrhosstu.filter(item => {
          // Use includes() for "like" (partial string match) functionality
          const nameMatches = item.stunm.toLowerCase().includes(sertxt.query.toLowerCase());
          // const typeMatches = item.type.toLowerCase().includes(lowerCaseSearchTerm);
          
          // Return true if either property matches the search term
          return nameMatches ; 
        });
      }
     
    
      
    Declinerequest()
    {
    if(confirm('Are you sure to decline leave request?') )
    {
    var postdata={leid:this.objbed.leid,lermk:this.objbed.lermk,tag:"men" };
      this.fservice.declinleaverequest(postdata)
          .subscribe(
          result => {
              console.log('SavegenmasDetails', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                // let localmodref=this.modalRef1;
                // localmodref.close();

                 let localmodref1=this.modalRef;
                localmodref1.close();
                this.objbed={};
                this.getstudents();
    
              }
             else
             {
    
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }
  }


      
    Approverequest()
    {
   
    var postdata={leid:this.objbed.leid,lermk:this.objbed.lermk,tag:"men" };
      this.fservice.approveleaverequest(postdata)
          .subscribe(
          result => {
              console.log('SavegenmasDetails', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                let localmodref=this.modalRef1;
                localmodref.close();

                 let localmodref1=this.modalRef;
                localmodref1.close();
                this.objbed={};
                this.getstudents();
    
              }
             else
             {
    
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }
  
    
    
    }
    